var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px-0"},[_c('NewsletterType',{attrs:{"draft":_vm.draft,"newsletter-types":_vm.newsletterTypes,"initial-value":_vm.initialValue},on:{"clearedDraft":_vm.onClearedDraft}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }